import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useCallback, useEffect, useMemo, useRef, } from 'react';
import { useHelpPopupWithRef } from 'shared/hooks/ui/help-popup/help-popup-ref';
import { Box, ListItemButton, Typography } from '@mui/material';
import { genericMemo } from 'console/shared/utils/memo';
import { CustomIcon } from '../../icon/custom';
import { useDesignPackage } from 'console/shared/hooks/helpers';
import { useInView } from 'framer-motion';
import { isSmallUI } from 'shared/app/lib/choose-ui-type';
import { removeNulls } from 'utils';
import { RocketLaunch } from '@mui/icons-material';
import { web_element_icons } from './icons';
export const IconItemWithPopup = genericMemo(forwardRef(function IconItemWithPopup(props, ref) {
    const { children, option, onClickPopupItem, demo, ...rest } = props;
    const [HelpPopup, refs, open, close] = useHelpPopupWithRef(false);
    const { similar } = option;
    const allow_design_package = useDesignPackage();
    const permission_design_package = useMemo(() => {
        if (demo) {
            return true;
        }
        return allow_design_package;
    }, [demo, allow_design_package]);
    const refView = useRef(null);
    const isInView = useInView(refView);
    const render_icons = useMemo(() => {
        if (option.similar) {
            return removeNulls(option.similar.map((id) => {
                return web_element_icons.find((el) => el.id === id) ?? null;
            }));
        }
        return [];
    }, [similar]);
    const onClickInPopup = useCallback((value) => () => {
        onClickPopupItem(value);
        close();
    }, [permission_design_package, onClickPopupItem, close]);
    const popup_icons = useMemo(() => render_icons.map((icon) => (_jsxs(ListItemButton, { onClick: onClickInPopup(icon.id), disabled: !permission_design_package && icon.paid, children: [_jsx(CustomIcon, { Icon: icon.render, width: "100%", height: "100%", viewBox: "0 0 32 32", sx: { fill: '#474747' } }), _jsx(Box, { ml: 1, children: icon.title }), icon.styled && (_jsx(Typography, { sx: { fontStyle: 'italic', pl: 1 }, children: "Styled" })), !permission_design_package && icon.paid ? (_jsx(RocketLaunch, { color: "primary", sx: { pl: 1 } })) : null] }, icon.id))), [render_icons]);
    useEffect(() => {
        if (!isInView) {
            close();
        }
    }, [isInView]);
    const isValidIcon = useMemo(() => {
        if (option && option.paid) {
            return permission_design_package;
        }
        return null;
    }, [option, permission_design_package]);
    return (_jsxs(_Fragment, { children: [_jsx(Box, { onClick: open, ref: refs, children: _jsx(Box, { ref: refView, children: children }) }), _jsx(HelpPopup, { placement: isSmallUI() ? 'top' : 'right', styleProps: { fontSize: 16, width: 250, whiteSpace: 'pre-line' }, children: popup_icons })] }));
}));
